import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { getLocalizedDateTime, getLocalizedName } from '../../localization/LocalizedString';
import '../../views/WorkList.css';

const WorkListItem = ({
  currentLanguage, item, translate, reasonModalHandler,
}) => {
  const {
    id,
    status,
    createdAt,
    devices,
    customer: {
      name: customerName,
      streetAddress: customerStreetAddress,
      postalCode: customerPostalCode,
      city: customerCity,
      phone: customerPhone,
      parkingInfo,
    },
    orderData: {
      subcontractor,
      deviceAdditionalProducts,
    },
  } = item;

  let shipmentId = '';
  if (devices != null && devices.length > 0) {
    shipmentId = devices[0].shipmentId;
  }

  const devicesNames = [];
  devices.forEach((device) => {
    const deviceName = getLocalizedName(device, currentLanguage);
    const notInstalledDeviceStatus = 'NOT_INSTALLED';
    const uncompletedDeviceStatus = 'UNCOMPLETED';
    const completedDeviceStatus = 'COMPLETED';
    const deviceStatus = (device.status === undefined ? '' : device.status.value);
    const deviceReason = (device.status === undefined ? '' : device.status.reason);

    let currentDeviceStatus = '';
    if (deviceStatus !== '' && completedDeviceStatus !== deviceStatus) {
      if (notInstalledDeviceStatus === deviceStatus) {
        currentDeviceStatus = translate('work_list.column_task.device-not-installed');
      } else if (uncompletedDeviceStatus === deviceStatus) {
        currentDeviceStatus = translate('work_list.column_task.device-uncompleted');
      }
      devicesNames.push(
        {
          deviceName,
          deviceStatus: (deviceStatus === 'NOT_INSTALLED' ? (
            <Link className="link"
                  to={{ pathname: '', key: uuid() }}
                  onClick={() => {
                    reasonModalHandler({ msg: deviceReason, showReasonModal: true, deviceNameAndStatus: `${deviceName} (${currentDeviceStatus})` });
                  }}>
              {' '}
              <span>
                {' '}
                (
                {currentDeviceStatus}
                )
                {' '}
              </span>
            </Link>
          ) : deviceStatus === 'UNCOMPLETED' ? (
            <Link className="link"
                  to={{ pathname: '', key: uuid() }}
                  onClick={() => {
                    reasonModalHandler({ msg: deviceReason, showReasonModal: true, deviceNameAndStatus: `${deviceName} (${currentDeviceStatus})` });
                  }}>
              {' '}
              <span>
                {' '}
                (
                {currentDeviceStatus}
                )
                {' '}
              </span>
            </Link>
          ) : (
            <span>
              {' '}
              (
              {currentDeviceStatus}
              {' '}
              )
              {' '}
            </span>
          )),
        },
      );
    } else {
      devicesNames.push({ deviceName, deviceStatus: '' });
    }
  });

  const devicesNamesString = devicesNames.map((line, idx) => (
    <div key={idx}>
      {line.deviceName}
      {' '}
      {line.deviceStatus}
      <br />
    </div>
  ));

  const deviceAdditionalProductNames = [];
  deviceAdditionalProducts.forEach((additionalProducts) => {
    deviceAdditionalProductNames.push(getLocalizedName(additionalProducts, currentLanguage));
  });
  const deviceAdditionalProductNamesString = deviceAdditionalProductNames.map((line, idx) => (
    <div key={idx}>
      {line}
      <br />
    </div>
  ));

  let timeAgreementDate = '';
  if (status.timeAgreementDates != null && status.timeAgreementDates.length > 0) {
    const lastAddedAgreementDate = status.timeAgreementDates[status.timeAgreementDates.length - 1];
    if (lastAddedAgreementDate != null) {
      const { startDate, endDate } = lastAddedAgreementDate;
      if (startDate != null && endDate != null) {
        const dateFmt = translate('work_list.column_task.agreement-date-format');
        const timeFmt = translate('work_list.column_task.agreement-time-format');
        timeAgreementDate = `${moment(startDate)
          .format(dateFmt)}-${moment(endDate)
          .format(timeFmt)}`;
      }
    }
  }

  return (
    <tr className="report-table-row_worklist">
      <td className="report-table-cell_worklist">
        <Link className="link"
              to={{
                pathname: `/installationservice/${shipmentId}`,
                state: { installationDocumentId: id },
                key: uuid(),
              }}>
          {shipmentId}
        </Link>
      </td>
      <td className="report-table-cell_worklist">{getLocalizedDateTime(new Date(createdAt), currentLanguage)}</td>
      <td className="report-table-cell_worklist">{getLocalizedName(subcontractor, currentLanguage)}</td>
      <td className="report-table-cell_worklist">{customerName}</td>
      <td className="report-table-cell_worklist">{customerStreetAddress}</td>
      <td className="report-table-cell_worklist">{customerPostalCode}</td>
      <td className="report-table-cell_worklist">{devicesNamesString}</td>
      <td className="report-table-cell_worklist">{deviceAdditionalProductNamesString}</td>
      <td className="report-table-cell_worklist">{customerCity}</td>
      <td className="report-table-cell_worklist">{customerPhone}</td>
      <td className="report-table-cell_worklist">{timeAgreementDate}</td>
      <td className="report-table-cell_worklist">{translate(`work_list.status.${status.value}`)}</td>
      <td className="report-table-cell_worklist">{parkingInfo === undefined ? '' : parkingInfo }</td>
    </tr>
  );
};

export default WorkListItem;
